import React from "react";

interface Props extends React.HTMLProps<HTMLElement> {}

export default function Comment({ className, children }: Props) {
  return <div className={`${className}`}>{children}</div>;
}
